import { paths } from '../paths';
import { lazyLoadPage } from '../utils';

export const sendGiftRoutes = [
  {
    path: paths.SEND_GIFT_OCCASIONS,
    element: lazyLoadPage('/send-gift/occasions', { path: '(dashboard)' }),
    state: {
      pageKey: 'SendGiftOccasions',
      metadata: {
        title: 'Send gift occasions'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.SEND_GIFT_CREATE_GIFT_LIST,
    element: lazyLoadPage('/send-gift/gift-list', { path: '(dashboard)' }),
    state: {
      pageKey: 'SendGiftCreateGiftList',
      metadata: {
        title: 'Send gift create gift list'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.SEND_GIFT_UPDATE_GIFT_LIST(),
    element: lazyLoadPage('/send-gift/[recognitionCode]/gift-list', { path: '(dashboard)' }),
    state: {
      pageKey: 'SendGiftUpdateGiftList',
      metadata: {
        title: 'Send gift update gift list'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.SEND_GIFT_REVIEW(),
    element: lazyLoadPage('/send-gift/[recognitionCode]/review', { path: '(dashboard)' }),
    state: {
      pageKey: 'SendGiftReview',
      metadata: {
        title: 'Send gift review'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.SEND_GIFT_CHECKOUT(),
    element: lazyLoadPage('/send-gift/[recognitionCode]/checkout', { path: '(dashboard)' }),
    state: {
      pageKey: 'SendGiftCheckout',
      metadata: {
        title: 'Send gift checkout'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.SEND_GIFT_CONFIRMATION(),
    element: lazyLoadPage('/send-gift/[recognitionCode]/confirmation', { path: '(dashboard)' }),
    state: {
      pageKey: 'SendGiftConfirmation',
      metadata: {
        title: 'Send gift confirmation'
      },
      shoppingCart: {
        enabled: false
      }
    }
  }
];
